import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { ccPaymentVM } from '../viewmodels/ccPaymentVM';
import { GetSBImagesQuery } from '../viewmodels/ISearchService';
import { Observable } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';
//import { isNumeric } from 'rxjs-compat/util/isNumeric';
import Swal from 'sweetalert2';


@Injectable()
export class CCPaymentService {
  myAppUrl: string = "";
  webSvcUrl: string = '';
  uid: string = '';
  pwd: string = '';
  //singleStepLocationId: string = '';
  locationId: string = '';
  totAmount: number = 0;
  ccPmt: ccPaymentVM;
  sbQuery: GetSBImagesQuery;
  infoEntered: number = 0;

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;


  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
    this.uid = 'aitllc';
    
    //////test
    //this.webSvcUrl = 'https://testapi.paygov.us/PaymentProcessingService.asmx'
    //this.pwd = 'T9r6gFzd'
    //this.locationId = '37128';

    ////prod
    this.webSvcUrl = 'https://ws3.paygov.us/PaymentProcessingService.asmx'
    this.pwd = '5snSTR2V'
    this.locationId = '39402';  

    this.ccPmt = new ccPaymentVM();
    this.sbQuery = new GetSBImagesQuery();
  }

  ngOnInit() {
//    this.resetCCPmt();
  }

  logServiceError(msg: string): boolean {
    let url = this.myAppUrl + 'api/CoreData/LogServiceError?msg=' + msg;
    //console.log('auth user - ' + url);
    this._http.get<boolean>(url).subscribe(
      (data => { console.log(data); })
    );
    return true;
  }


  resetCCPmt() {
    console.log('ccPmt ' + this.ccPmt.ccNum);
    this.ccPmt.authCode = '';
    this.ccPmt.ccNum = '';
    this.ccPmt.realccNum = '';
    this.ccPmt.ccFname = '';
    this.ccPmt.ccLname = '';
    this.ccPmt.ccMonth = '';
    this.ccPmt.ccYear = '';
    this.ccPmt.ccv = '';
    this.ccPmt.ccZip = '';
    this.ccPmt.orderId = '';
    this.ccPmt.ccAmount = 0;
    this.ccPmt.status = '';
    this.infoEntered = 0;
  }

  async getCreditCardInfo() {

 //   console.log('cc info');
 //   console.log('ccPmt2 ' + this.ccPmt.ccNum);


    let x = await Swal.fire({
      title: 'Enter Credit Card Info',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<br>' +
        '<table>' +
        '<tr><td><label for="ccnum"   style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Card Number</label></td><td><input id="ccnum" type="text" maxlength="19" size="30" placeholder="0000 0000 0000 0000" value="' + '' + '"> </td></tr > ' +
        '<tr><td><label for="ccfname" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">First Name</label></td><td><input id="ccfname" type="text" size="30" value="' + this.ccPmt.ccFname + '"></td></tr>' +
        '<tr><td><label for="cclname" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Last Name</label></td><td><input id="cclname" type="text" size="30" value="' + this.ccPmt.ccLname + '"></td></tr>' +
        '<tr><td><label for="ccmonth" style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Exp Month</label></td><td style="text-align: left"><input id="ccmonth" type="text" size="5" maxlength="2" placeholder="00" value="' + this.ccPmt.ccMonth + '"></td></tr>' +
        '<tr><td><label for="ccyear"  style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Exp Year</label></td><td style="text-align: left"><input id="ccyear" type="text" size="5" maxlength="2" placeholder="00" value="' + this.ccPmt.ccYear + '"></td></tr>' +
        '<tr><td><label for="ccv"     style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">CCV</label></td><td style="text-align: left"><input id="ccv" type="text" size="5" maxlength="4" placeholder="0000" value="' + this.ccPmt.ccv + '"></td></tr>' +
        '<tr><td><label for="cczip"   style="display: inline-block; width: 150px; text-align: right; padding-right: 5px;">Zip Code</label></td><td style="text-align: left"><input id="cczip" type="text" size="5" maxlength="5" placeholder="00000" value="' + this.ccPmt.ccZip + '"></td></tr>' +
        '</table>' +
        '<br> *** The cost for this download is $' + this.totAmount.toString() + ' - a convenience fee of 3 percent will be added to this charge, with a minimum convenience fee of $1.00. <p style="color:red; font-weight:500;">Charges will appear on your statement as<br> PayGov, Indianapolis, IN</p>. ',

      focusConfirm: true,
      preConfirm: () => {
        return [
          this.ccPmt.ccNum = (<HTMLInputElement>document.getElementById('ccnum')).value,
          this.ccPmt.ccFname = (<HTMLInputElement>document.getElementById('ccfname')).value,
          this.ccPmt.ccLname = (<HTMLInputElement>document.getElementById('cclname')).value,
          this.ccPmt.ccMonth = (<HTMLInputElement>document.getElementById('ccmonth')).value,
          this.ccPmt.ccYear = (<HTMLInputElement>document.getElementById('ccyear')).value,
          this.ccPmt.ccv = (<HTMLInputElement>document.getElementById('ccv')).value,
          this.ccPmt.ccZip = (<HTMLInputElement>document.getElementById('cczip')).value
        ]
      }
    }).then((result) => {
      if (result.dismiss === undefined) {
        console.log('cc ok');
        this.infoEntered = 1;
      }
      else {
        this.infoEntered = 0;
        console.log('cc cancel');
        return;
      }
    });
  }

  async authorizeCard() {

    this.logServiceError('begin CC Auth');

    //validate card info
    this.ccPmt.realccNum = this.ccPmt.ccNum.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g, "");
    if (this.ccPmt.ccMonth.length === 1)
      this.ccPmt.ccMonth = '0' + this.ccPmt.ccMonth;
    this.ccPmt.ccAmount = this.totAmount;

    let msg = this.ValidateCard(this.ccPmt);
    if (msg === '') {

      this.logServiceError('CC validated');

      this.ccPmt.authCode = '';
      let response = '';
//      this.showLoader = true;
//      this.sendLoader();

      //this.ccPmt.transType = 1; //single step authorization
      await this.getCCAuth(this.ccPmt).toPromise()
        .then(data => {
          //console.log('data ' + data);
          response = data;
          this.ccPmt.status = this.getElement(data, '<PaymentStatus>');
          if (this.ccPmt.status === 'Declined') {
//            let responseText = this.getElement(data, '<ResponseText>');
            this.logServiceError('CC Payment Declined - ' + response);
//            this.showLoader = false;
//            this.sendLoader();
            Swal.fire('Payment Declined')
          }
          else if (this.ccPmt.status === 'Authorized' || this.ccPmt.status === 'Pending') {
            //approved
            this.ccPmt.authCode = this.getElement(data, '<AuthorizationTransactionCode>');
            this.sbQuery.authCode = this.ccPmt.authCode;
            //this.serviceFee = +this.ccPmtSvc.getElement(data, '<ServiceFeeAmount>');
            this.ccPmt.orderId = this.getElement(data, '<OrderId>');
            console.log('Payment Authorized - ' + this.ccPmt.authCode + ' - ' + this.ccPmt.orderId);
            this.logServiceError('Export Payment Authorized - ' + this.ccPmt.authCode + ' - ' + this.ccPmt.orderId); // + ' ' + this.machineType);

          //  //all is well - branch for download vs print
          //  if (this.machineType === 0)
          //    this.getSB();
          //  else if (this.machineType === 1)
          //    this.printSB();
          //  else
          //    this.service.logServiceError("Error - " + this.machineType);
          }
          else {
            //log the different status
            this.logServiceError('Unknown Payment Status - ' + response);
//            this.showLoader = false;
 //           this.sendLoader();
          }
        });
    }
    else {
      //validation failed - go back to the cc form
      this.logServiceError('CC not validated - ' + msg);
      await Swal.fire('Validation Error', msg);
    }
    //    this.showLoader = false;
    //    this.sendLoader();
  }


  completeSBChargeandCCSale(search: GetSBImagesQuery): Observable<any> {
 //   console.log('completeSBChargeandCCSale ' + search.orderId);

    let url_ = this.myAppUrl + "api/CoreData/completeSBChargeandCCSale";
//    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
//    console.log(content_);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: 'json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this._http.request("post", url_, options_);

  }



  getElement(xml: string, elem: string): string {
    let pos1 = xml.indexOf(elem);
    let elem2 = '</' + elem.substr(1);
    let pos2 = xml.indexOf(elem2);
    let ret = xml.substring(pos1 + elem.length, pos2);

    return ret;
  }

  getCCAuth(ccPmt: ccPaymentVM): Observable<any> {

    console.log('getCCAuth');

    //let locationId = this.twoStepLocationId;
    //if (this.ccPmt.transType === 1)
    //  locationId = this.singleStepLocationId;

    let content_ = '<?xml version="1.0" encoding="UTF-8"?>'
    content_ += '<soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:pay="http://PayGov.us/">'
    content_ += '    <soap:Header/>'
    content_ += '        <soap:Body>'
    content_ += '            <pay:ProcessCCPaymentByLocationCode>'
    content_ += '            <pay:apiUserId>' + this.uid + '</pay:apiUserId>'
    content_ += '            <pay:apiPassword>' + this.pwd + '</pay:apiPassword>'
    content_ += '            <pay:locationCodeId>' + this.locationId + '</pay:locationCodeId>'
    content_ += '            <pay:firstName>' + ccPmt.ccFname + '</pay:firstName>'
    content_ += '            <pay:lastName>' + ccPmt.ccLname + '</pay:lastName>'
    content_ += '            <pay:address1></pay:address1>'
    content_ += '            <pay:address2></pay:address2>'
    content_ += '            <pay:city></pay:city>'
    content_ += '            <pay:state></pay:state>'
    content_ += '            <pay:zip>' + ccPmt.ccZip + '</pay:zip>'
    content_ += '            <pay:phone></pay:phone>'
    content_ += '            <pay:email></pay:email>'
    content_ += '            <pay:mobilePhone></pay:mobilePhone>'
    content_ += '            <pay:paymentAmount>' + ccPmt.ccAmount + '</pay:paymentAmount>'
    content_ += '            <pay:cardNumber>' + ccPmt.realccNum + '</pay:cardNumber>'
    content_ += '            <pay:expirationMonth>' + ccPmt.ccMonth + '</pay:expirationMonth>'
    content_ += '            <pay:expirationYear>' + ccPmt.ccYear + '</pay:expirationYear>'
    content_ += '            <pay:cvv2>' + ccPmt.ccv + '</pay:cvv2>'
    content_ += '            <pay:track1/>'
    content_ += '            <pay:lstUserData>'
    content_ += '            <pay:UserData>'
    content_ += '                <pay:Id>0</pay:Id>'
    content_ += '                <pay:UserValue></pay:UserValue>'
    content_ += '            </pay:UserData>'
    content_ += '            </pay:lstUserData>'
    content_ += '            <pay:userId>00000000-0000-0000-0000-000000000000</pay:userId>'
    content_ += '            <pay:invoiceId/>'
    content_ += '            <pay:handlingFee>0</pay:handlingFee>'
    content_ += '            </pay:ProcessCCPaymentByLocationCode>'
    content_ += '        </soap:Body>'
    content_ += '</soap:Envelope>';


    let options_: any = {
      body: content_,
      headers: new HttpHeaders({
        'Content-Type': 'text/xml',
        'Accept': 'text/xml'
      }),
      responseType: 'text'
    };

//    console.log(content_);
//    console.log(options_);

    return this._http.request("post", this.webSvcUrl, options_);

  }

  ccCompleteSale(ccPmt: ccPaymentVM): Observable<any> {

    console.log('ccCompleteSale');

    let content_ = '<?xml version="1.0" encoding="UTF-8"?>'
    content_ += '  <soap:Envelope xmlns:soap = "http://www.w3.org/2003/05/soap-envelope" xmlns:pay = "http://PayGov.us/">'
    content_ += '      <soap:Header />'
    content_ += '      <soap:Body>'
    content_ += '          <pay:CaptureTransaction>'
    content_ += '              <pay:apiUserId>' + this.uid + '</pay:apiUserId>'
    content_ += '              <pay:apiPassword>' + this.pwd + '</pay:apiPassword>'
    content_ += '              <pay:orderId>' + ccPmt.orderId + '</pay:orderId>'
    content_ += '              <pay:amount>' + ccPmt.ccAmount + '</pay:amount>'
    content_ += '          </pay:CaptureTransaction>'
    content_ += '      </soap:Body>'
    content_ += '    </soap:Envelope>'


    let options_: any = {
      body: content_,
      headers: new HttpHeaders({
        'Content-Type': 'text/xml',
        'Accept': 'text/xml'
      }),
      responseType: 'text'
    };

//        console.log(content_);
    //    console.log(options_);

    return this._http.request("post", this.webSvcUrl, options_);
  }

  voidTransaction(ccPmt: ccPaymentVM): Observable<any> {

    console.log('voidTrans');

    let content_ = '<?xml version="1.0" encoding="UTF-8"?>'
    content_ += '  <soapenv:Envelope xmlns:soapenv = "http://schemas.xmlsoap.org/soap/envelope/" xmlns:pay = "http://PayGov.us/" >'
    content_ += '    <soapenv:Header />'
    content_ += '      <soapenv:Body>'
    content_ += '        <pay:VoidOrRefundTransaction>'
    content_ += '            <pay:apiUserId >' + this.uid + '</pay:apiUserId>'
    content_ += '            <pay:apiPassword >' + this.pwd + '</pay:apiPassword>'
    content_ += '            <pay:orderId>' + ccPmt.orderId + '</pay:orderId>'
    content_ += '            <pay:refundReason>AIT</pay:refundReason>'
    content_ += '        </pay:VoidOrRefundTransaction>'
    content_ += '      </soapenv:Body>'
    content_ += '  </soapenv:Envelope>'

    let options_: any = {
      body: content_,
      headers: new HttpHeaders({
        'Content-Type': 'text/xml',
        'Accept': 'text/xml'
      }),
      responseType: 'text'
    };

//    console.log(content_);
    //    console.log(options_);

    return this._http.request("post", this.webSvcUrl, options_);
  }


  ValidateCard(ccPmt: ccPaymentVM): string {

    let msg = '';

    ccPmt.realccNum = ccPmt.ccNum.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g, "");
    if (ccPmt.ccMonth.length === 1)
      ccPmt.ccMonth = '0' + ccPmt.ccMonth;

    if (ccPmt.realccNum.length === 0)
      msg = 'Credit Card Number is required'
    else if (isNaN(+ccPmt.realccNum))
      msg = 'Credit Card Number must be numeric';
    else if (ccPmt.realccNum.length < 15)
      msg = 'Credit Card Number incomplete';
    else if (!this.checkSum(ccPmt.realccNum))
      msg = 'Invalid Credit Card Number'
    else if (ccPmt.ccFname.length === 0)
      msg = 'First Name Required';
    else if (ccPmt.ccLname.length === 0)
      msg = 'Last Name Required';
    else if (ccPmt.ccFname.length === 0)
      msg = 'First Name Required';
    else if (ccPmt.ccMonth.length === 0)
      msg = 'Expiration Month is required'
    else if (isNaN(+ccPmt.ccMonth))
      msg = 'Expiration Month must be numeric';
    else if (+ccPmt.ccMonth < 1 || +ccPmt.ccMonth > 12)
      msg = 'Expiration Month is out of range';
    else if (ccPmt.ccYear.length === 0)
      msg = 'Expiration Year is required';
    else if (isNaN(+ccPmt.ccYear))
      msg = 'Expiration Year must be numeric';
    else if (+ccPmt.ccYear < new Date().getFullYear() - 2000)
      msg = 'Expiration Year is out of range';
//    else if (+ccPmt.ccYear === new Date().getFullYear() - 2000 && +ccPmt.ccMonth < new Date().getMonth())
//      msg = "Expiration Year and Month out of range";
    else if (ccPmt.ccv.length === 0)
      msg = 'CCV is required'
    else if (isNaN(+ccPmt.ccv))
      msg = 'CCV must be numeric';
    else if (ccPmt.ccv.length < 3)
      msg = 'CCV must be at least 3 digits';
    else if (ccPmt.ccZip.length === 0)
      msg = 'Zip Code is required'
    else if (ccPmt.ccZip.length < 5)
      msg = 'A valid Zip Code must be entered';
    else if (isNaN(+ccPmt.ccZip))
      msg = 'Zip Code must be numeric';

    return msg;
  }

  checkSum(ccNum: string): boolean {
    const ccNumber: string = ccNum;
    const luhnArray: Array<number> = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    let length: number = ccNumber ? ccNumber.length : 0;
    let sum = 0;
    let shouldMultiply = true;

    console.log(ccNumber);
    while (length) {
      const val: number = parseInt(ccNumber.charAt(--length), 10);
      //console.log(luhnArray[val]);
      sum += (shouldMultiply = !shouldMultiply) ? luhnArray[val] : val;
      //console.log(sum)
    }
    //return !(sum && sum % 10 === 0) ;
    console.log('checksum - ' + !(sum && sum % 10 === 0)) ;
    return true;
  }


}
